import { render, staticRenderFns } from "./PurchaseOrderInfo.vue?vue&type=template&id=08157622&"
import script from "./PurchaseOrderInfo.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports